import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/about/components/AboutCompanyDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/about/components/AboutHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/about/components/AboutTimeline.tsx");
